<template>
    <div class="orgaBox borderBox wrap">
        <div class="newStyle borderBox">
           <div class="listBox borderBox">
                <div class="add-search">
                   <searchCon
                        :searchCon="searchCon"
                        @search="search"
                        ref="search"
                        @searchHeight="searchHeight"
                        >
                        <el-button slot="operation" type="success" @click="addO">新增</el-button>
                    </searchCon>
                    
                </div>
                <!--table-->
                <div class="tableCon">
                    <tableInfo
                            ref="table"
                            :table="table">
                        <template slot="amount" slot-scope="{obj}">
                            <span v-if="obj.amount || obj.amount == 0">{{tool.toFixed(obj.amount)}}</span>
                        </template>
                        
                    </tableInfo>
                </div>
                <!--分页-->
                <pageCon
                        ref="page"
                        :total="total"
                        @changePage="changePage">
                </pageCon>
                <!--用户编辑弹窗-->
                <dialogTitle
                        width="600px"
                        :title="dialog.title"
                        :dialogTitleVisible="dialog.isOpen"
                        @closeCheck="closeDialog('formData','dialog')">
                    <el-form
                            class="form "
                            :model="formData"
                            ref="formData"
                            :rules="rules"
                            label-width="120px">
                    </el-form>
                    <template>
                        <!-- <div class="dialogSlotCon" slot="footer">
                            <el-button class="newBtn" @click="legalPersonFormSubmit('formData')">确定</el-button>
                            <el-button  @click="closeDialog('formData','dialog')" >取消</el-button>
                        </div> -->
                    </template>
                </dialogTitle>
           </div>
        </div>
    </div>
</template>

<script>
    import { selectionChange,tableHeight} from '@/mixins/table';
    import searchTable from "@/mixins/searchTable";
    import dialogTitle from '@/components/dialogs/dialogTitle';
    import {mapGetters} from "vuex";
    import { isMobile } from "@/utils/validate";
    export default {
        name: "parameterList",
        mixins: [ selectionChange,searchTable,tableHeight],
        computed: {
            ...mapGetters(['page'])
        },
        components: {
            dialogTitle
        },
        data() {
            return {
                //添加修改表单校验规则
                rules: {
                },
                //分页请求到的数据总数
                total: 0,
                //用户列表table
                table: {
                    loading: true,
                    hasSelect: false,
                    hasClickEvent: true,
                    highlight: true,
                    labelProps: [
                        {label: "参数编码", prop: "paraCode",minWidth:110},
                        {label: "参数名称", prop: "paraName",minWidth:180},
                        {label: "参数类型", prop: "paraType",},
                        {label: "取值类型", prop: "gainType"},
                        {label: "取值脚本", prop: "gainScript",minWidth: 80},
                        {label: "余额", prop: "amount",show:'template'},
                        {label: "创建时间", prop: "setUpDate", show: 'template'},
                        {label: "修改时间", prop: "state", show: 'template'},
                        {label: "操作", prop: "custId", show: 'template'},

                    ],
                    data: [],
                },
                //查询条件
                searchCon: {
                    selectData: [
                        {
                            placeholder:'参数类型',
                            name:'paraType',
                            value: 3,
                            clearable:false, //下拉框不能清除
                            data:[
                                {id:'1',name:'33'},
                                {id:3,name:'3333'},
                            ],
                        }
                    ],
                    inputsData: [
                        {placeholder: "参数编码", name: "paraCode"},
                        {placeholder: "参数名称", name: "paraName"},
                    ],
                },
                searchWords:{},
                currentPage:null,
                dialog:{
                    title:'',
                    isOpen:false
                },
                formData:{

                }
            }
        },
        methods: {
            initList(start, length) {
                let params = {
                    pageNo: start || 1,
                    pageSize: this.page.page_size,
                    ...this.searchWords
                };
                this.table.loading = false;
                // pageBossUserInfoVO(params).then(res =>{
                //     this.table.loading = false;
                //     if(res.success){
                //         this.table.data = res.data.result;
                //         this.total = res.data.total;
                //     } else{
                //         this.$message.error(res.msg)
                //     }
                // }).catch(res =>{
                //     this.table.loading = false;
                //     this.$message.error(res.msg)
                // })
            },
            //当前页码改变
            changePage(val) {
                this.currentPage = val;
                this.initList(val);
            },
            addO() {
                this.dialog.isOpen = true;
                this.dialog.title = '新建';
            },
            closeDialog(formData,name) {
                this.$nextTick(res => {
                    this.$refs[formData].resetFields();
                })
                this.isShow = false;
                this[name].isOpen = false;
            }
        },
    }
</script>

<style scoped lang="scss">
</style>
